<template>
  <div>
    <!-- <b-modal
      :visible="show"
      :size="size"
      @hide="onHide"
      @show="onShow"
      :centered="true"
      content-class="p-4"
      :no-close-on-backdrop="true"
      :hide-header="hideHeader"
      :hide-footer="hideFooter"
    >
      <template #modal-header>
        <div
          class="d-flex justify-content-between flex-fill header"
          :style="headerStyle"
        >
          <div class="d-flex">
            <div class="modal-cus-title">
              <slot name="header"> Title </slot>
            </div>
            <div class="modal-cus-subTitle">
              <slot name="subHeader">
                 SubHeader
              </slot>
            </div>
          </div>
          <div class="modal-buttons">
            <div
              v-if="tooltipText"
              class="modal-info-btn"
              id="btn-info-modal"
              v-tooltip:left="tooltipText"
            >
              <BaseIcon
                name="info"
                width="1.25rem"
                height="1.25rem"
                class="modal-base-icon"
              />
            </div>
            <div class="modal-close-btn" @click="onClose" id="btn-close-modal">
              <BaseIcon
                v-if="closeButtonVariant === 'primary'"
                name="closeButtonModal"
              />
              <BaseIcon v-else name="closeButtonGray"></BaseIcon>
            </div>
          </div>
        </div>
      </template>
      <template>
        <slot name="body"> Body </slot>
      </template>
      <template #modal-footer>
        <div class="mFooter" :style="footerStyle">
          <slot name="footer"> Footer </slot>
        </div>
      </template>
    </b-modal> -->
  </div>
</template>

<script>
export default {
  name: 'RexModal',
  props: {
    size: { type: String, required: true, default: 'sm' },
    show: { type: Boolean, required: true, default: false },
    tooltipText: { type: String, default: '' },
    footerStyle: { type: Object, default: () => {} },
    headerStyle: { type: Object, default: () => {} },
    closeButtonVariant: { type: String, default: 'primary' },
    hideFooter: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false },
  },
  methods: {
    onHide(evt) {
      if (evt.trigger === 'backdrop') {
        evt.preventDefault();
        this.$emit('onHide', false);
      }
    },
    onClose() {
      this.$emit('onClose', false);
    },
    onShow() {
      this.$emit('onShow', true);
    },
  },
};
</script>

<style lang="scss">
.action1 {
  display: inline;
  cursor: pointer;
}

.subHeader {
  display: flex !important;
  margin: 0.9em 0 0 -1em !important;
  color: $font-primary;
}

.modal-cus-title {
  color: $color-brand-accent;
  font-size: 1.75em;
  font-family: $semi-bold;
  margin-right: 1.2em;
}
.head-subhead {
  @include flex-center-vert;
}
.subhead {
  margin-left: 2em;
}
.modal-close-btn {
  cursor: pointer;
}
.modal-info-btn {
  cursor: pointer;
  margin-right: 1.4rem;
}
.modal-buttons {
  display: flex;
  align-items: center;
}
.mFooter {
  width: 100%;
  margin: 0rem !important;
}
.modal-base-icon {
  @include svg-fill($color-brand-accent);
}
@media screen and (max-width: 1199px) {
  .header,
  .mFooter {
    font-size: 10px;
  }
}

@media screen and (min-width: 1200px) {
  .header,
  .mFooter {
    font-size: 14px;
  }
}
@media screen and (min-width: 1600px) {
  .header,
  .mFooter {
    font-size: 16px;
  }
}
</style>
